import Favorites from "../components/Favorites/Favorites";

const FavoritesPage = () => {
  return <Favorites />;
};

export default FavoritesPage;
